// Textos de ayuda de los campos de capa (QA-73).
// Viven acá y no en cada formulario porque los mismos campos aparecen en el de ArcGIS y en el
// de GeoServer: una sola definición evita que las dos explicaciones se separen con el tiempo.

export const LAYER_FIELD_HELP = {
  nombre:
    'Nombre con que la capa se lista en el árbol de capas del visor y aparece en los informes.',
  descripcion:
    'Texto breve que describe qué muestra la capa. Se ve en la ficha de la capa dentro del visor.',
  url:
    'Dirección del servicio que publica la capa. Debe partir con http:// o https:// y no terminar en "/".',
  codigo:
    'Índice de la subcapa dentro del servicio ArcGIS: el número que va al final de la URL del servicio, por ejemplo /0. Se guarda en este campo y no en la URL.',
  fuente:
    'Institución u origen de los datos de la capa. Es informativo: se muestra como referencia y no afecta el funcionamiento.',
  esVulnerable:
    'Define si la capa puede entrar en los geoprocesos. Con NO la capa nunca participa, aunque esté cargada o se seleccione manualmente.',
  reportIconSvg:
    'SVG vectorial opcional para representar la capa vulnerable en el reporte. Admite distintos viewBox o dimensiones numéricas y se ajusta automáticamente; si no se carga uno se utiliza el icono predeterminado.',
  capPoblacion:
    'Marca la capa como base de población para los informes de geoprocesos. Elige Polígonos o Puntos según cómo estén representados los habitantes. NO significa que la capa no aporta población.',
  categoria:
    'Categoría bajo la que la capa aparece agrupada en el árbol de capas del visor.',
  orden:
    'Posición de la capa dentro de su categoría en el árbol de capas. Menor número, más arriba.',
  workspace:
    'Espacio de trabajo (workspace) de GeoServer donde está publicada la capa.',
  datastore:
    'Nombre de la capa dentro del espacio de trabajo. Junto al espacio de trabajo forma el identificador que se le pide a GeoServer, con el formato espacio:capa.'
};
